const LIST_UNIT = [
  "Fasilitas Umum",
  "Hubungan Masyarakat",
  "ITF",
  "Janitor",
  "Keamanan",
  "Kemahasiswaan",
  "Keuangan",
  "Magister Teknologi Informasi",
  "Perpustakaan",
  "Riset dan Pengabdian Kepada Masyarakat",
  "Sekretariat Akademik",
  "Sekretariat Pimpinan",
  "Sumber Daya Manusia",
];

export default LIST_UNIT;
